export function nativeFrameLength(imageFrame) {
    const { rows, columns, samplesPerPixel, bitsAllocated } = imageFrame;
    const samples = rows * columns * samplesPerPixel;
    if (bitsAllocated === 1) {
        return Math.ceil(samples / 8);
    }
    return samples * (bitsAllocated / 8);
}
export function trimToNativeFrame(imageFrame, pixelData, context) {
    const expected = nativeFrameLength(imageFrame);
    if (pixelData.length === expected) {
        return pixelData;
    }
    if (pixelData.length < expected) {
        throw new Error(`${context}: frame is ${pixelData.length} bytes, expected ${expected} for ` +
            `${imageFrame.rows}x${imageFrame.columns} with ${imageFrame.samplesPerPixel} ` +
            `sample(s) at ${imageFrame.bitsAllocated} bits`);
    }
    return pixelData.subarray(0, expected);
}
